var _path, _g, _path2, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAmenagementInt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 251,
    viewBox: "0 0 250 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_621_1419",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 51,
    width: 113,
    height: 179
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M134.7 51.1195H22.6499V229.97H134.7V51.1195Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_621_1419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.04 91.8895V55.8495L41.2401 59.4695V95.5095L35.04 91.8895Z",
    fill: "#B2E8C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.24 108.879V65.5995L47.4399 61.9795V105.259L41.24 108.879Z",
    fill: "#72D09A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.7 102.56H22.6499V195.82H134.7V102.56Z",
    fill: "#B2E8C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6699 229.97C109.61 229.97 134.69 214.22 134.69 194.79C134.69 175.36 109.61 159.609 78.6699 159.609C47.7299 159.609 22.6499 175.36 22.6499 194.79C22.6499 214.22 47.7299 229.97 78.6699 229.97Z",
    fill: "#B2E8C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.7 102.57V195.82H134.66C133.8 214.52 109.73 229.56 79.8999 229.97V102.57H134.7Z",
    fill: "#29A063"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6699 137.579C105.45 137.579 127.16 122.779 127.16 104.529C127.16 86.2795 105.45 71.4795 78.6699 71.4795C51.8899 71.4795 30.1699 86.2795 30.1699 104.529C30.1699 122.779 51.8799 137.579 78.6699 137.579Z",
    fill: "#FECECA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6699 139.33C105.45 139.33 127.16 125.69 127.16 108.87C127.16 92.0495 105.45 78.4095 78.6699 78.4095C51.8899 78.4095 30.1699 92.0395 30.1699 108.87C30.1699 125.7 51.8799 139.33 78.6699 139.33Z",
    fill: "#F97E73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6699 69.2195C47.7299 69.2195 22.6499 84.9695 22.6499 104.399C22.6499 123.829 47.7299 139.589 78.6699 139.589C109.61 139.589 134.69 123.829 134.69 104.399C134.69 84.9695 109.61 69.2195 78.6699 69.2195ZM78.6699 134.239C51.8799 134.239 30.1699 120.599 30.1699 103.779C30.1699 86.9595 51.8799 73.3195 78.6699 73.3195C105.46 73.3195 127.16 86.9595 127.16 103.779C127.16 120.599 105.45 134.239 78.6699 134.239Z",
    fill: "#B2E8C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.62 101.87L35.04 54.7395L41.2401 51.1195L121.83 98.2595L115.62 101.87Z",
    fill: "#72D09A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.62 109.109L35.04 61.9795V54.7395L115.62 101.87V109.109Z",
    fill: "#B2E8C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.43 141.54V105.5L115.62 109.109V145.16L109.43 141.54Z",
    fill: "#B2E8C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.62 145.16V101.87L121.83 98.2595V141.54L115.62 145.16Z",
    fill: "#29A063"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_621_1419",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 123,
    y: 20,
    width: 105,
    height: 185
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M227.35 20.9495H123.92V204.109H227.35V20.9495Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_621_1419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.49 133.289L161.14 139.299L171.49 145.319L181.83 139.299L171.49 133.289Z",
    fill: "#B2E8C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.49 204.449V145.319L181.83 139.299V198.429L171.49 204.449Z",
    fill: "#72D09A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.49 204.449V145.319L161.14 139.299V198.429L171.49 204.449Z",
    fill: "#B2E8C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.22 44.0194C152.55 34.7194 152.55 24.6694 147.22 21.5794C141.89 18.4794 133.25 23.4994 127.92 32.7994C122.59 42.0894 122.59 52.1394 127.92 55.2394C133.25 58.3394 141.89 53.3194 147.22 44.0194Z",
    fill: "#FECECA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.58 54.9794L197.22 95.3894L215.32 62.1694L146.61 21.8594L128.58 54.9794Z",
    fill: "#FECECA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.28 62.1594L205.62 78.3094L148.34 43.9994L138.72 38.4094L128.03 32.1994C130.33 28.0894 133.27 25.0094 137.52 22.5394C140.74 20.6694 144.03 20.5594 146.57 21.8694C146.6 21.8794 146.63 21.8894 146.66 21.9094L147.18 22.2094L147.22 22.2294L215.28 62.1594Z",
    fill: "#F97E73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.01 84.3694C221.34 75.0694 221.34 65.0194 216.01 61.9194C210.68 58.8194 202.04 63.8494 196.71 73.1394C191.38 82.4394 191.38 92.4894 196.71 95.5894C202.04 98.6894 210.68 93.6594 216.01 84.3694Z",
    fill: "#F97E73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.15 85.3394L202.52 74.5094L208.73 70.8894L227.35 81.7194L221.15 85.3394Z",
    fill: "#B2E8C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.15 92.5494L202.52 81.7194V74.5094L221.15 85.3394V92.5494Z",
    fill: "#B2E8C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.94 124.879V88.9395L221.15 92.5494V128.489L214.94 124.879Z",
    fill: "#B2E8C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.15 128.489V85.3395L227.35 81.7195V124.879L221.15 128.489Z",
    fill: "#72D09A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.27 139.479V95.9994L171.48 99.6194V143.079L165.27 139.479Z",
    fill: "#B2E8C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.48 143.079V92.3994L177.69 88.7894V139.479L171.48 143.079Z",
    fill: "#72D09A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.94 124.879L165.28 95.9994L165.14 88.7894L214.94 117.659V124.879Z",
    fill: "#B2E8C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.94 117.659L165.21 88.7895L171.41 85.1794L214.94 110.449V117.659Z",
    fill: "#B2E8C5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmenagementInt);
export default __webpack_public_path__ + "static/media/amenagementINT.c32c14158f9a9eff3d261ec9d5fc1914.svg";
export { ForwardRef as ReactComponent };